export default __webpack_public_path__ + "static/media/contact overview.e9f2898b.png";